import { NewTag } from "@/components/Tag";
import { GradientBorderContainer } from "@/containers/GradientContainer/GradientContainer";
import { lock as lockIcon } from "@/icons";
import { cn } from "@/lib/utils";
import { NavLink } from "react-router";

interface EvolutionsHubCardProps {
  title: string;
  description: string;
  link?: string;
  disabled?: boolean;
  icon: {
    text: string;
    icon: React.ReactNode;
  };
  imageUrl: string;
  isNew?: boolean;
  active?: boolean;
}
export const EvolutionsHubCard = ({
  title,
  description,
  link,
  disabled,
  icon,
  isNew,
  imageUrl,
  active,
}: EvolutionsHubCardProps) => {
  const className = cn(
    "w-full",
    disabled && "brightness-75 cursor-not-allowed",
    "rounded-md border border-2 border-transparent",
    active && "border-emerald-500",
  );

  const content = (
    <div className="relative">
      <div className="relative w-full min-h-[120px]">
        <img
          className="size-full object-cover absolute top-0 left-0 rounded-[6px] h-[120px]"
          src={imageUrl || ""}
          alt={description}
        />
        <div
          className="absolute inset-0 w-full h-full rounded-[6px]"
          style={{
            background:
              "linear-gradient(0deg, #1A1E23 0%, rgba(26, 30, 35, 0.52) 50.08%, rgba(26, 30, 35, 0.15) 79.78%, rgba(26, 30, 35, 0.00) 100%)",
            boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
          }}
        />
        <div className="absolute bottom-3 left-3 w-full flex flex-col gap-y-2 max-touch-device:gap-y-1 max-touch-device:left-1">
          <div className="flex flex-row items-center gap-x-2">
            <div className="text-white font-oswald text-xl font-medium">
              {title}
            </div>
            {isNew && <NewTag />}
          </div>

          <GradientBorderContainer
            className="flex flex-row w-fit gap-x-1 rounded-2xl px-1.5 py-1 text-xs touch-device:text-sm font-semibold items-center max-touch-device:px-0.5"
            fill="#133831"
            from="#047857"
            to="transparent"
          >
            <div className="text-emerald-400">{icon.icon}</div>
            <div className="text-emerald-200">{icon.text}</div>
          </GradientBorderContainer>
        </div>
      </div>
      {!active && (
        <div className="absolute inset-0 w-full h-full rounded-md transition-all duration-200 bg-black/60 hover:bg-black/20"></div>
      )}
    </div>
  );
  if (link && !disabled) {
    return (
      <NavLink to={link} state={{ from: "/evolutions" }} className={className}>
        {content}
      </NavLink>
    );
  }
  return <div className={className}>{content}</div>;
};
